import axios from "axios";
import {
  SIGN_UP_BEGIN,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  VERIFY_EMAIL_BEGIN,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  SET_LOGIN_USER_STATUS,
  START_LOGIN,
  CLEAR_AUTH_DATA,
  FORGET_PASSWORD_STARTED,
  FORGET_PASSWORD_SUCCESS,
  SET_USER_PROFILE_DATA,
  UPDATE_PASSWORD_STARTED,
  UPDATE_PROFILE_STARTED,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_ORGANIZATION_STARTED,
  UPDATE_ORGANIZATION_SUCCESS,
  RESET_PASSWORD_STARTED,
  RESET_PASSWORD_SUCCESS,
  LOGIN_EMAIL_VERIFY,
} from "../actionTypeConstants/constants";
import { toast } from "react-toastify";
import { Redirect } from "react-router-dom";
import {
  setAccessToken,
  removeAccessToken,
  getAccessToken,
} from "../../helpers/genericHelpers";
import { baseUrl } from "../../environments/environment";

export const signUpBegin = () => {
  const action = {
    type: SIGN_UP_BEGIN,
  };
  return action;
};
export const signUpSuccess = (data) => {
  const action = {
    type: SIGN_UP_SUCCESS,
    payload: data,
  };
  return action;
};
export const signUpFailure = () => {
  const action = {
    type: SIGN_UP_FAILURE,
  };
  return action;
};

export const signUp = (data) => {
  return (dispatch) => {
    dispatch(signUpBegin());
    axios
      .post(`${baseUrl}/signup`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(signUpSuccess(res.data.user));
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};

export const setUserProfileData = (data) => {
  const action = {
    type: SET_USER_PROFILE_DATA,
    payload: {
      profileData: data,
    },
  };
  return action;
};

export const fetchProfileData = () => {
  return (dispatch) => {
    axios
      .get(`${baseUrl}/user/${getAccessToken().id}`, {
        headers: {
          "Content-type": "application/json",
          "API-Token": getAccessToken().api_token,
        },
      })
      .then((res) => {
        dispatch(setUserProfileData(res.data.data.user));
      })
      .catch((err) => {
        // if(res.status === 'error') {
        //   toast.error(res.message)
        // }
      });
  };
};

// verify email functions

export const verifyEmailBegin = () => {
  const action = {
    type: VERIFY_EMAIL_BEGIN,
  };
  return action;
};
export const verifyEmailSuccess = () => {
  const action = {
    type: VERIFY_EMAIL_SUCCESS
  };
  return action;
};
export const verifyEmailFailure = () => {
  const action = {
    type: VERIFY_EMAIL_FAILURE,
  };
  return action;
};

export const verifyEmail = (data) => {
  return (dispatch) => {
    dispatch(setIsLoginStart(true));
    axios
      .post(`${baseUrl}/user/${data.id}/email/verify`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          setAccessToken(res.data.user);
          dispatch(setIsLoginStart(false));
          dispatch(setUserLoginStatus(true));
          dispatch(verifyEmailSuccess());
          toast.success(res.message);
          dispatch(fetchProfileData());
          
        }
      })
      .catch(function (error) {
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};

// login functions

export const setUserLoginStatus = (success) => {
  const action = {
    type: SET_LOGIN_USER_STATUS,
    payload: {
      success,
    },
  };
  return action;
};

export const setIsLoginStart = (isStarted) => {
  const action = {
    type: START_LOGIN,
    payload: {
      isStarted,
    },
  };
  return action;
};

export const loginVerifyEmail = (data) => {
  const action = {
    type: LOGIN_EMAIL_VERIFY,
    payload: data,
  };
  return action;
};

export const doLogin = (data) => {
  return (dispatch) => {
    dispatch(setIsLoginStart(true));
    axios
      .post(`${baseUrl}/signin`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          setAccessToken(res.data.user);
          dispatch(setIsLoginStart(false));
          dispatch(setUserLoginStatus(true));
          // toast.success(res.message);
          dispatch(fetchProfileData());
        }
      })
      .catch(function (error) {
        dispatch(setIsLoginStart(false));
        const res = error.response.data || {};
        if (res.status === "error") {
          
          if(res.type === "EmailVerificationError") {
            dispatch(loginVerifyEmail(res.data.user))
            toast.warn("Your email is not verified. First verify your email");
          } else {
            toast.error(res.message);
          }
        }
      });
  };
};

const removeToken = () => {
  removeAccessToken();
};

export const validateToken = () => {
  return (dispatch) => {
    dispatch(setIsLoginStart(true));
    axios
      .get(`${baseUrl}/user/${getAccessToken().id}`, {
        headers: {
          "Content-type": "application/json",
          "API-Token": getAccessToken().api_token,
        },
      })
      .then((res) => {
        dispatch(setUserLoginStatus(true));
        dispatch(setIsLoginStart(false));
        dispatch(setUserProfileData(res.data.data.user));
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 400) {
          dispatch(doLogout());
        }
        // if(res.status === 'error') {
        //   toast.error(res.message)
        // }
      });
  };
};

export const doLogout = () => {
  removeToken();
  const action = {
    type: CLEAR_AUTH_DATA,
  };
  return action;
};


export const resendCode = (data) => {
  return (dispatch) => {
    axios
      .post(`${baseUrl}/user/${data.id}/token/resend`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};


export const setIsUpdatePasswordStarted = (isStarted) => {
  const action = {
    type: UPDATE_PASSWORD_STARTED,
    payload: {
      isStarted,
    },
  };
  return action;
};

export const updatePassword = (data) => {
  return (dispatch) => {
    dispatch(setIsUpdatePasswordStarted(true));
    axios
      .post(`${baseUrl}/user/${getAccessToken().id}/password/change`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
          "API-Token": getAccessToken().api_token,
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(setIsUpdatePasswordStarted(false));
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        dispatch(setIsUpdatePasswordStarted(false));
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};


export const setIsUpdateProfileStarted = (isStarted) => {
  const action = {
    type: UPDATE_PROFILE_STARTED,
    payload: {
      isStarted,
    },
  };
  return action;
};
export const updateProfileSuccess = (data) => {
  const action = {
    type: UPDATE_PROFILE_SUCCESS,
    payload: {
      data
    }
  };
  return action;
};

export const updateProfile = (data) => {
  return (dispatch) => {
    dispatch(setIsUpdateProfileStarted(true));
    axios
      .put(`${baseUrl}/user/${getAccessToken().id}/update`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
          "API-Token": getAccessToken().api_token,
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(setIsUpdateProfileStarted(false));
          dispatch(updateProfileSuccess(data));
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        dispatch(setIsUpdateProfileStarted(false));
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};




export const setIsUpdateOrganizationStarted = (isStarted) => {
  const action = {
    type: UPDATE_ORGANIZATION_STARTED,
    payload: {
      isStarted,
    },
  };
  return action;
};
export const updateOrganizationSuccess = (data) => {
  const action = {
    type: UPDATE_ORGANIZATION_SUCCESS,
    payload: {
      data
    }
  };
  return action;
};

export const updateOrganization = (data) => {
  return (dispatch) => {
    dispatch(setIsUpdateOrganizationStarted(true));
    axios
      .put(`${baseUrl}/organization/${getAccessToken().id}/update`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
          "API-Token": getAccessToken().api_token,
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(setIsUpdateOrganizationStarted(false));
          dispatch(updateOrganizationSuccess(data));
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        dispatch(setIsUpdateOrganizationStarted(false));
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};






export const setIsForgetPasswordStarted = (isStarted) => {
  const action = {
    type: FORGET_PASSWORD_STARTED,
    payload: {
      isStarted,
    },
  };
  return action;
};
export const forgetPasswordSuccess = (data) => {
  const action = {
    type: FORGET_PASSWORD_SUCCESS,
    payload: {
      data
    }
  };
  return action;
};

export const forgetPassword = (data) => {
  return (dispatch) => {
    dispatch(setIsForgetPasswordStarted(true));
    axios
      .post(`${baseUrl}/password/forget`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(setIsForgetPasswordStarted(false));
          dispatch(forgetPasswordSuccess(res.data.user));
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        dispatch(setIsForgetPasswordStarted(false));
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};




export const setIsResetPasswordStarted = (isStarted) => {
  const action = {
    type: RESET_PASSWORD_STARTED,
    payload: {
      isStarted,
    },
  };
  return action;
};
export const resetPasswordSuccess = (data) => {
  const action = {
    type: RESET_PASSWORD_SUCCESS,
    payload: {
      data
    }
  };
  return action;
};

export const resetPassword = (data) => {
  return (dispatch) => {
    dispatch(setIsResetPasswordStarted(true));
    axios
      .post(`${baseUrl}/user/${data.id}/password/reset`, JSON.stringify(data), {
        headers: {
          "Content-type": "application/json",
        },
      })
      .then(function (response) {
        const res = response.data;
        if (res.status === "error") {
          toast.error(res.message);
        }
        if (res.status === "success") {
          dispatch(setIsResetPasswordStarted(false));
          dispatch(resetPasswordSuccess(res.data.user));
          setAccessToken(res.data.user);
          dispatch(setUserLoginStatus(true));
          toast.success(res.message);
        }
      })
      .catch(function (error) {
        dispatch(setIsResetPasswordStarted(false));
        const res = error.response.data || {};
        if (res.status === "error") {
          toast.error(res.message);
        }
      });
  };
};